/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright Copyright (c) 2021, Zumper
 */

import type { State } from '@zcode/state-type'
import { differenceInDays } from 'date-fns'
import { compose } from 'redux'

export const selectProfile = (state: State) => state.profile.profile

export const selectProfileId = compose((profile) => profile.profile_id, selectProfile)

export const selectProfileAutoSharePrequalLastModified = compose(
  (profile) => profile?.explicit?.AUTO_SHARE_PREQUAL?.modified_on,
  selectProfile
)

export const selectFetchedProfile = (state: State) => state.profile.fetchedProfile

export const selectProfileMoveInValue = compose(
  (profile) => profile?.explicit?.MOVE_IN?.value,
  selectProfile
)

export const selectProfileIsAutoSharePrequal = (state: State) => {
  const profile = selectProfile(state)
  const profileId = selectProfileId(state)
  const lastModified = selectProfileAutoSharePrequalLastModified(state)

  return !!(
    lastModified &&
    profileId &&
    profile?.explicit?.AUTO_SHARE_PREQUAL &&
    profile?.explicit?.AUTO_SHARE_PREQUAL.value !== 'false' &&
    differenceInDays(new Date(), new Date(lastModified * 1000)) <= 30
  )
}
